const SLUG_IMAGE_MAP: Record<string, string> = {
  "ai-as-your-creative-copilot": "/blog-images/ai-as-your-creative-copilot.jpg",
  "ai-thumbnail-generation-guide":
    "/blog-images/ai-thumbnail-generation-guide.jpg",
  "ai-video-script-writing-guide":
    "/blog-images/ai-video-script-writing-guide.jpg",
  "ai-video-translation-guide": "/blog-images/ai-video-translation-guide.jpg",
  "author-voice-identity-optimization":
    "/blog-images/author-voice-identity-optimization.jpg",
  "best-ai-tools-youtube-thumbnails-2026":
    "/blog-images/best-ai-tools-youtube-thumbnails-2026.jpg",
  "best-time-to-post-youtube": "/blog-images/best-time-to-post-youtube.jpg",
  "building-1000-true-fans": "/blog-images/building-1000-true-fans.jpg",
  "cognitive-load-in-creator-economy":
    "/blog-images/cognitive-load-in-creator-economy.jpg",
  "community-tab-engagement-strategy":
    "/blog-images/community-tab-engagement-strategy.jpg",
  "consistent-creators-calendar":
    "/blog-images/consistent-creators-calendar.jpg",
  "copyright-and-originality-guide":
    "/blog-images/copyright-and-originality-guide.jpg",
  "creator-mental-health-matters":
    "/blog-images/creator-mental-health-matters.jpg",
  "ctr-the-promise-you-make": "/blog-images/ctr-the-promise-you-make.jpg",
  "diagnose-music-video-before-release":
    "/blog-images/diagnose-music-video-before-release.jpg",
  "diy-channel-audit-guide": "/blog-images/diy-channel-audit-guide.jpg",
  "evolution-video-intelligence-meaning-first-patent":
    "/blog-images/evolution-video-intelligence-meaning-first-patent.jpg",
  "finding-your-niche-voice": "/blog-images/finding-your-niche-voice.jpg",
  "getting-4000-watch-hours-authentically":
    "/blog-images/getting-4000-watch-hours-authentically.jpg",
  "how-to-start-youtube-channel-2026":
    "/blog-images/how-to-start-youtube-channel-2026.jpg",
  "how-to-translate-youtube-videos-ai-voice-cloning":
    "/blog-images/how-to-translate-youtube-videos-ai-voice-cloning.jpg",
  "meaning-first-growth-strategy-2026":
    "/blog-images/meaning-first-growth-strategy-2026.jpg",
  "meaning-first-keyword-strategy":
    "/blog-images/meaning-first-keyword-strategy.jpg",
  "meaning-first-video-optimization":
    "/blog-images/meaning-first-video-optimization.jpg",
  "meaningful-collaborations": "/blog-images/meaningful-collaborations.jpg",
  "minimalist-gear-guide": "/blog-images/minimalist-gear-guide.jpg",
  "reading-retention-graphs-for-storytelling":
    "/blog-images/reading-retention-graphs-for-storytelling.jpg",
  "reviving-a-stagnant-channel": "/blog-images/reviving-a-stagnant-channel.jpg",
  "scripting-for-impact-and-retention":
    "/blog-images/scripting-for-impact-and-retention.jpg",
  "shorts-vs-long-form-unified-strategy":
    "/blog-images/shorts-vs-long-form-unified-strategy.jpg",
  "sustainable-monetization-strategies":
    "/blog-images/sustainable-monetization-strategies.jpg",
  "understanding-2026-youtube-algorithm":
    "/blog-images/understanding-2026-youtube-algorithm.jpg",
  "vidseeds-official-launch-december-2025":
    "/blog-images/vidseeds-official-launch-december-2025.jpg",
  "vidseeds-vs-vidiq-vs-tubebuddy":
    "/blog-images/vidseeds-vs-vidiq-vs-tubebuddy.jpg",
  "welcome-to-vidseeds-blog": "/blog-images/welcome-to-vidseeds-blog.jpg",
  "youtube-algorithm-changes-2026-seo-tips":
    "/blog-images/youtube-algorithm-changes-2026-seo-tips.jpg",
  "youtube-algorithm-demystified-2025":
    "/blog-images/youtube-algorithm-demystified-2025.jpg",
  "youtube-analytics-for-storytellers":
    "/blog-images/youtube-analytics-for-storytellers.jpg",
  "youtube-analytics-guide": "/blog-images/youtube-analytics-guide.jpg",
  "youtube-description-generator-guide":
    "/blog-images/youtube-description-generator-guide.jpg",
  "youtube-seo-guide-2025": "/blog-images/youtube-seo-guide-2025.jpg",
  "youtube-seo-guide-2026": "/blog-images/youtube-seo-guide-2026.jpg",
  "youtube-shorts-optimization-2025":
    "/blog-images/youtube-shorts-optimization-2025.jpg",
  "youtube-shorts-strategy-2026":
    "/blog-images/youtube-shorts-strategy-2026.jpg",
  "youtube-thumbnail-best-practices":
    "/blog-images/youtube-thumbnail-best-practices.jpg",
  "youtube-title-optimization-tips":
    "/blog-images/youtube-title-optimization-tips.jpg",
};

const DEFAULT_BLOG_IMAGE = "/blog-images/default.jpg";

/**
 * Get the cover image for a blog post by slug.
 */
export function getBlogPostImage(slug: string): string {
  return SLUG_IMAGE_MAP[slug] || DEFAULT_BLOG_IMAGE;
}
